import { render } from "./dsp-market.vue?vue&type=template&id=2ecfc519"
import script from "./dsp-market.js?vue&type=script&lang=js"
export * from "./dsp-market.js?vue&type=script&lang=js"

import "./dsp-market.vue?vue&type=style&index=0&id=2ecfc519&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__